import cn from 'clsx'
import { Image } from '~/components/image'
import s from './clouds.module.css'

export function CloudCard({ data, className }) {
  return (
    <div
      className={cn(
        'flex flex-col justify-between flex-shrink-0 dr-gap-8 dr-w-242 h-fit dr-mr-10 dr-px-15 dr-py-12 bg-white text-black dr-rounded-12',
        s.cloud__card,
        className
      )}
    >
      <p className="cta-md-s break-words whitespace-normal">“{data?.text}“</p>
      <figure className="flex items-center dr-gap-6">
        <picture className="relative flex-shrink-0 dr-w-30 dr-h-30 dr-rounded-9999 overflow-hidden">
          <Image
            src={data?.media?.filename}
            alt={data?.name || 'Profile picture'}
            className="!w-full !h-full !object-cover"
          />
        </picture>
        <figcaption className="flex flex-col ">
          <span className="username">{data?.name}</span>
          <div className="cta-md-s flex items-center dr-gap-4">
            <span>{data?.position}</span>
            <Image
              src={data?.logo?.filename}
              alt={data?.name.alt || 'Company logo'}
              className="!dr-h-14"
            />
          </div>
        </figcaption>
      </figure>
    </div>
  )
}
